export default {
  "content": "<path fill=\"#707070\" d=\"M21.438 12.5l-3.594-1.406a.92.92 0 00-.719 0L13.531 12.5c-.312.125-.531.438-.531.75 0 3.5 2.125 5.906 4.125 6.688a.931.931 0 00.719 0C19.437 19.313 22 17.155 22 13.25c0-.313-.219-.625-.563-.75zM17.5 18.469v-5.907l2.969 1.157c-.188 2.719-1.907 4.219-2.969 4.75zM9 12c2.188 0 4-1.781 4-4 0-2.188-1.813-4-4-4-2.219 0-4 1.813-4 4 0 2.219 1.781 4 4 4zm3 1.25c0-.063 0-.125.031-.219-.094 0-.156-.031-.25-.031h-.531c-.688.344-1.438.5-2.25.5-.813 0-1.594-.156-2.281-.5h-.532C3.876 13 2 14.906 2 17.219V18.5c0 .844.656 1.5 1.5 1.5h11c.188 0 .406-.031.594-.125C13.406 18.562 12 16.25 12 13.25z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none",
    "viewBox": "0 0 24 24"
  }
};